import { useState, useEffect } from 'react';
import { 
  Modal, TextInput, ScrollArea, Center, Loader, 
  Stack, Paper, Group, Text, Badge 
} from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import api from '../api/axiosConfig';

export default function PhoneDirectoryModal({ opened, onClose }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    // Modal açıldığında ve veriler henüz çekilmediyse fetch işlemi yap
    if (opened && contacts.length === 0) {
      setLoading(true);
      api.get('/ip-phone')
        .then((res) => {
          if (res.data) setContacts(res.data);
        })
        .catch((error) => {
          console.error("Rehber verileri çekilemedi:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [opened, contacts.length]);

  // Arama filtresi
  const filteredContacts = contacts.filter(contact => 
    contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    contact.ext.includes(searchTerm)
  );

  return (
    <Modal 
      opened={opened} 
      onClose={() => {
        setSearchTerm(""); // Kapanırken aramayı temizle
        onClose();
      }} 
      title="Kurumsal Rehber" 
      size="md" 
      centered
    >
      <TextInput 
        placeholder="İsim veya dahili ara..." 
        leftSection={<IconSearch size={16} />} 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.currentTarget.value)} 
        mb="md" 
      />
      
      <ScrollArea h={350} offsetScrollbars>
        {loading ? (
          <Center h="100%">
            <Loader color="cyan" size="sm" />
          </Center>
        ) : (
          <Stack gap="sm">
            {filteredContacts.length > 0 ? (
              filteredContacts.map(contact => (
                <Paper key={contact.id} withBorder p="sm" radius="md" bg="gray.0">
                  <Group justify="space-between">
                    <Stack gap={0}>
                      <Text fw={600} size="sm">{contact.name}</Text>
                      {contact.title && <Text size="xs" c="dimmed">{contact.title}</Text>}
                    </Stack>
                    <Badge color="cyan" variant="light">Dhl: {contact.ext}</Badge>
                  </Group>
                </Paper>
              ))
            ) : (
              <Text ta="center" size="sm" c="dimmed" py="xl">Sonuç bulunamadı.</Text>
            )}
          </Stack>
        )}
      </ScrollArea>
    </Modal>
  );
}